import React from 'react';
import self from '../../../apis/self';
import {ReactSVG} from 'react-svg';

/**
 * main menu component on navbar
 */
class NavbarMainMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            navs: []
        };
    }

    componentDidMount() {
        if (this.state.navs.length === 0) {
            this.getNavs();
        }
    }

    /**
     * get Navigation
     *
     * @returns {Promise<void>}
     */
    getNavs = async () => {
        const response = await self.get('/navigations/1', {
            timeout: 20000
        });
        if (response) {
            this.setState({
                navs: response.data
            });
        } else {
            //TODO: ERROR HANDLING ON GET LAYERS
            console.log('get Navigations failed');
            console.log(response);
        }
    }

    /**
     * render layer list to jsx
     *
     * @returns {unknown[]}
     */
    renderNavList() {
        return this.state.navs.map(nav => {
            return (
                <div className="dropdown-item" key={nav.id}>
                    {nav.child.length ?
                        <a href={`#subnav-${nav.id}`} className="has-toggle" role="button" data-toggle="collapse">
                            <span>
                                {nav.title}
                            </span>
                            <ReactSVG className="toggle-icon react-svg"
                                      src="/img/maps/icon/chevron.svg"/>
                        </a>
                        :
                        <a href={nav.uri} role="button" target={nav.target}>
                            <span>
                                {nav.title}
                            </span>
                        </a>
                    }
                    {nav.child.length ?
                        <div className="subnav-container collapse" data-parent="#navbar-main-menu-collapse"
                             id={`subnav-${nav.id}`}>
                                {this.renderSubNav(nav)}
                        </div>
                        : ''
                    }
                </div>
            );
        });
    }

    renderSubNav(nav) {
        return nav.child.map(subNav => {
            return (
                <div className="dropdown-item" key={subNav.id}>
                    <a href={subNav.uri} role="button" target={subNav.target}>
                        <span>
                            {subNav.title}
                        </span>
                    </a>
                </div>
            )
        });
    }

    render() {
        return (
            <div className="collapse navbar-collapse" id="navbar-main-menu-container">
                <ul className="navbar-nav" id="navbar-main-menu">
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle hamburger-button" href="#" role="button"
                           data-toggle="dropdown">
                            <div className="hamburger-icon">
                                <span/>
                                <span/>
                                <span/>
                                <span/>
                                <span/>
                                <span/>
                            </div>
                        </a>
                        <div className="dropdown-menu" id="navbar-main-menu-collapse">
                            {this.renderNavList()}
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}

export default NavbarMainMenu;